export const TEST_STATUS = {
  PASSED: "passed",
  FAILED: "failed",
  IN_PROGRESS: "in_progress",
  NOT_STARTED: "not_started",
} as const;
